/* eslint react-hooks/rules-of-hooks: "warn" */
import { isString } from 'lodash';
import React from 'react';
import { CoreAPI, useIdentity } from '../../../core';
import { getEditorOperateState } from '../../states/editor-operate-state';
import { HOTKEY_TYPE, hotkeyConfigArr } from '../config';
import { useKeyPressListener } from '../hooks/use-key-press-listener';

export const HotkeyEvent = React.memo(() => {
    const identity = useIdentity();
    const configs = hotkeyConfigArr();
    const coreApi = CoreAPI(identity);

    function checkIsDisableOperate(hotkeyConfig?: any) {
        const editorOperateState = getEditorOperateState(identity);
        if (editorOperateState.disableOperate || coreApi.getShowContextMenu() || editorOperateState.isMouseSelect)
            return true;
        if (hotkeyConfig && editorOperateState.disablePick && !hotkeyConfig.ignoreDisablePick) {
            return true;
        }
        return false;
    }

    for (let i = 0; i < configs.length; i++) {
        const hotkeyConfig = configs[i];
        const press = hotkeyConfig.press;
        if (!press.length) continue;
        if (hotkeyConfig.key === HOTKEY_TYPE.move) {
            const keys = [HOTKEY_TYPE.up, HOTKEY_TYPE.right, HOTKEY_TYPE.down, HOTKEY_TYPE.left];
            for (let j = 0; j < press.length; j++) {
                useKeyPressListener([press[j] as string], () => {
                    if (checkIsDisableOperate(hotkeyConfig)) return;
                    coreApi.events.emit(keys[j]);
                });
            }
        } else if (hotkeyConfig.key === HOTKEY_TYPE.quickMove) {
            const keys = [HOTKEY_TYPE.quickUp, HOTKEY_TYPE.quickRight, HOTKEY_TYPE.quickDown, HOTKEY_TYPE.quickLeft];
            for (let j = 0; j < press.length; j++) {
                useKeyPressListener([press[j] as string], () => {
                    if (checkIsDisableOperate(hotkeyConfig)) return;
                    coreApi.events.emit(keys[j]);
                });
            }
        } else if (isString(press[0])) {
            useKeyPressListener(press as string[], () => {
                if (checkIsDisableOperate(hotkeyConfig)) return;
                if (hotkeyConfig.key === HOTKEY_TYPE.esc) {
                    coreApi.events.emitEsc();
                } else if (hotkeyConfig.key === HOTKEY_TYPE.delete) {
                    coreApi.events.emitDelete();
                } else {
                    coreApi.events.emit(hotkeyConfig.key);
                }
            });
        } else {
            for (let j = 0; j < press.length; j++) {
                useKeyPressListener(press[j] as string[], () => {
                    if (checkIsDisableOperate(hotkeyConfig)) return;
                    coreApi.events.emit(hotkeyConfig.key, j);
                });
            }
        }
    }

    useKeyPressListener(['enter'], () => {
        if (checkIsDisableOperate()) return;
        coreApi.events.emitEnter();
    });

    return null;
});
